export default "__VITE_ASSET__Dsfpwrb7__";